import Api from "~/service/Api";

class Immersive3dTourZipProjectRepository {
  fetchOne(tourId, query) {
    return Api.get(`/immersive-3d-tour/zip-projects/${tourId}`, query);
  }
}

export default Immersive3dTourZipProjectRepository;
